import React from 'react';
import { RULE_TYPE_NAME } from './constant';

export const isReadyToSubmit = (data = {}, validationStates = {}) => {
    const { ruleNameValid, costCenterValid } = validationStates;

    // Check for missing required validation states
    const requiredStates = ['ruleNameValid', 'costCenterValid'];
    const missingStates = requiredStates?.filter((state) => !(state in validationStates));

    if (missingStates?.length > 0) {
        return { isValid: false, message: `Missing required validation states: ${missingStates?.join(', ')}` };
    }

    // Check for missing mandatory properties
    const mandatoryProperties = ['ruleName', 'budgetCode'];
    const missingProperty = mandatoryProperties?.find((property) => !data?.[property]);

    if (missingProperty) {
        return { isValid: false, message: `Missing mandatory property: ${missingProperty}` };
    }

    if (!ruleNameValid) {
        return { isValid: false, message: 'Rule Name is invalid' };
    }

    if (!costCenterValid) {
        return { isValid: false, message: 'BudgetCode is invalid' };
    }

    const trustedRequestorRow = data?.ruleRows?.find((row) => row?.ruleType === RULE_TYPE_NAME?.TRUSTED_REQUESTOR);
    if (trustedRequestorRow && (!trustedRequestorRow?.value || !trustedRequestorRow?.value?.length)) {
        return { isValid: false, message: 'Missing the Trusted Requestors' };
    }

    const catalogServices = data?.ruleRows?.find((row) => row?.ruleType === RULE_TYPE_NAME?.CATALOG);
    if (catalogServices && (!catalogServices?.value || !catalogServices?.value?.length)) {
        return { isValid: false, message: 'Missing the catalogServices' };
    }

    const maxOrderAmount = data?.ruleRows?.find((row) => row?.ruleType === RULE_TYPE_NAME?.BUDGET_AMOUNT);
    if (maxOrderAmount && (!maxOrderAmount?.value || maxOrderAmount?.value <= 0)) {
        return { isValid: false, message: 'Invalid value for property: maxOrderAmount' };
    }
    return { isValid: true, message: 'All checks passed successfully' };
};

export default React.memo(isReadyToSubmit);
